import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { AllSameKeyValuesEnforcer } from './../helpers/helpers';
import { makeMapFromListOfObjectsAndKey } from 'globals/helpers/helpers';
import { JoiResource } from 'globals/store/resources.data';
import { Ranking } from 'globals/store/events.data';
import { eventsActions } from './events.era';
import { createReducer, on } from '@ngrx/store';

export interface ResourcesState extends EntityState<JoiResource> {
  resourceTypes: { [id:string]: Ranking }
}

interface ResourceDisplayTypes { readOnly, widePod, narrowPod, staticCard }
export const resourceDisplayTypes: AllSameKeyValuesEnforcer<ResourceDisplayTypes> = { readOnly: 'readOnly', widePod: 'widePod', narrowPod: 'narrowPod', staticCard: 'staticCard' }

const getDefaultResources= (): ResourcesState => ({
  ids: [],
  entities: {},
  resourceTypes: {}
})

export const adapter = createEntityAdapter<JoiResource>()
export const makeInitialState = (): ResourcesState => adapter.getInitialState(getDefaultResources())

export const resourcesReducer = createReducer(
  makeInitialState(),
  on(eventsActions.loadEvent, (state, action) => {
    const newState = {...adapter.upsertMany(Object.values(action.payload.resources), state)}
    newState.resourceTypes = makeMapFromListOfObjectsAndKey(action.payload.resourceTypes, 'id')
    return newState
  }),
  on(eventsActions.unloadEvent, (state) => ({ ...makeInitialState() })),
)
export const resourcesFeature = {
  name: 'resources',
  reducer: resourcesReducer,
  selectResourcesState: (state) => state.resources as ResourcesState
}

export const resourcesStateSelector = (state) => state.resources as ResourcesState